import { gql } from '@apollo/client';

export const accordionBlockFragment = gql`
  fragment accordionBlock on AccordionBlock {
    __typename
    sys {
      ...sys
    }
    heading
    bodyContent {
      ...accordionBlockRT
    }
    accordionItemsCollection(limit: 10) {
      items {
        heading
        bodyContent {
          ...accordionItemRT
        }
      }
    }
  }

  fragment accordionBlockRT on AccordionBlockBodyContent {
    json
    links {
      ...accordionBlockRTLinks
    }
  }

  fragment accordionBlockRTLinks on AccordionBlockBodyContentLinks {
    entries {
      block {
        sys {
          ...sys
        }
      }
      inline {
        sys {
          ...sys
        }
        ...mediaAsset
      }
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }

  fragment accordionItemRT on AccordionItemBodyContent {
    json
    links {
      ...accordionItemRTLinks
    }
  }

  fragment accordionItemRTLinks on AccordionItemBodyContentLinks {
    entries {
      block {
        sys {
          ...sys
        }
      }
      inline {
        sys {
          ...sys
        }
        ...mediaAsset
      }
      hyperlink {
        ...hyperlink
        ...mediaAsset
      }
    }
  }
`;
